import { GeoJSONSource, GeoJSONSourceSpecification } from 'mapbox-gl';
import {
  Ride,
  RideListRide,
  RideOrRouteOrSegment,
  RideOrRouteSegment,
  RideSegment,
  RidesItem,
  Route,
  RoutesItem,
  WeatherHour,
  WeatherHourly,
} from '../types';

export const isActivity = (ride: RideOrRouteOrSegment): ride is Ride => {
  return typeof (ride as Ride).type === 'string' && String((ride as Ride).type).toLowerCase() !== 'route';
};

export const isRide = (ride: RideOrRouteOrSegment): ride is Ride => {
  return String((ride as Ride).type).toLowerCase() === 'ride';
};

export const isRoute = (route: RideOrRouteOrSegment): route is Route => {
  return typeof (route as Route).type === 'number';
};

export const isRideItem = (ride: RideListRide): ride is RidesItem => {
  return String(ride.type).toLowerCase() === 'ride';
};

export const isRouteItem = (route: RideListRide): route is RoutesItem => {
  return typeof route.type === 'number';
};

export const isRideSegment = (segment: RideOrRouteOrSegment): segment is RideSegment => {
  return (segment as Ride).map === undefined && (segment as RideSegment).starred !== undefined;
};

export const isRideOrRouteSegment = (segment: RideOrRouteOrSegment): segment is RideOrRouteSegment => {
  return (segment as Ride).map === undefined;
};

export const isHourlyWeatherArray = (weather: WeatherHourly['data']): weather is WeatherHour[] => {
  return Array.isArray(weather);
};

export const isGeoJsonSource = (source: any): source is GeoJSONSource => {
  return source.setData !== undefined;
};

export const isGeoJsonSourceRaw = (source: any): source is GeoJSONSourceSpecification => {
  return source.type === 'geojson' && source.data !== undefined && typeof source.data !== 'string';
};

export const isFeatureGeoJson = (geoJson: any): geoJson is GeoJSON.Feature<GeoJSON.Geometry> => {
  return geoJson.type === 'Feature' && geoJson.geometry !== undefined;
};

export const isFeatureCollectionGeoJson = (geoJson: any): geoJson is GeoJSON.FeatureCollection<GeoJSON.Geometry> => {
  return geoJson.type === 'FeatureCollection' && Array.isArray(geoJson.features);
};

export const isTouchEvent = (e: any): e is TouchEvent => {
  return e.targetTouches;
};
